import { emptyApi } from "./emptyApi";

type DateFormat = {
  format: string;
  example: string;
};

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getDateFormats: build.query<DateFormat[], void>({
      query: () => {
        return {
          url: `/api/inkle/bookkeeping/date_formats/`,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetDateFormatsQuery } = extendedApi;
